


export enum NatureType {
  Air = 1,
  Emulsion= 2,
  ANFO= 3,
  Emulsion_ANFOsup60= 4,
  Emulsion_ANFOinf50= 5,
  Dynamite= 6,
  Gel= 7,
  Booster= 8,
  Other= 9,
}
  